import { ActionTree } from 'vuex'
import { IUserState, IUserInfo, EDeveloperStatus } from './types'
import { getUserInfo, logout } from '@/apps/open/services/user'
import { Message } from 'element-ui'
import router from '@/apps/open/router'
import { changeEmail } from '@/apps/open/services/developer'

const actions: ActionTree<IUserState, any> = {
  GET_USER_INFO: async ({ commit }) => {
    try {
      const res = await getUserInfo()
      const userInfo = res.data.object
      commit('SET_USER_INFO', userInfo)
      return Promise.resolve(userInfo)
    } catch (error) {
      commit('SET_USER_INFO')
      return Promise.reject(error)
    }
  },

  LOGOUT: async ({ commit }) => {
    try {
      await logout()
      commit('SET_USER_INFO')
      commit('SET_CUR_ENTERPRISE', null)
      router.replace({ name: 'home' })
    } catch (error) {
      Message.error(error.message)
    }
  },

  CHANGE_DEVELOPER_EMAIL: async ({ commit }, { email, developer_id }) => {
    try {
      await changeEmail(email, developer_id)
      // commit('CHANGE_DEVELOPER_EMAIL', email)
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  },

  SET_DEVELOPER_LIST ({ rootGetters, commit }, isInitSelect = true) {
    const platformDevelopers: any = []
    const enterpriseDevelopers: any = []
    const userDevelopers = rootGetters['User/userInfo'].developers
    const enterpriseList = rootGetters['Plussvr/enterpriseList']

    userDevelopers && userDevelopers.forEach((developer: any) => {
      if (developer.developer_type === 0) {
        platformDevelopers.push(developer)
      } else if (developer.developer_type === 1) {
        const enterpriseInfo = enterpriseList.find((el: any) => el.id === developer.company_id)
        enterpriseDevelopers.push({
          ...developer,
          ...(enterpriseInfo || {})
        })
      }
    })
    const unRegisterDevelopers = enterpriseList.filter((enterp: any) => {
      return !enterpriseDevelopers.find((el: any) => el.company_id === enterp.id)
    })
    const allEnterpriseList = [
      ...platformDevelopers,
      ...enterpriseDevelopers,
      ...unRegisterDevelopers
    ]
    commit('SET_ALL_DEVELOPERS', allEnterpriseList)
    if (allEnterpriseList.length <= 1 || isInitSelect) {
      commit('SET_CUR_ENTERPRISE', allEnterpriseList[0])
    }
  }
}

export default actions
